import { currenciesListSignature } from "@/utils/currenciesLoader";
import {
  createDefaultApiCache,
  getCurrenciesCacheKey,
  getPreviousTransactionCacheKey,
  invalidateCurrenciesCache,
  invalidatePreviousTransactionCache,
} from "@/utils/sessionDataCache";

export default {
  resetApiCache(state) {
    state.apiCache = createDefaultApiCache();
  },
  patchApiCache(state, patch) {
    state.apiCache = { ...state.apiCache, ...patch };
  },
  setPreviousTransactionCache(state, { key, result }) {
    state.apiCache.previousTransactionKey = key;
    state.apiCache.previousTransactionResult = result;
    state.apiCache.previousTransactionAt = Date.now();
  },
  setStocks(state, stocks) {
    state.stocks = stocks;
  },
  setConversionInfo(state, info) {
    state.conversionInfo = info;
  },
  setUserInfo(state, info) {
    state.userInfo = info;
  },
  setEnableDashboard(state, info) {
    state.enableDashboard = info;
  },
  setCart(state, cart) {
    // это чтобы не было конфликтов, если кто-то не передает кол-во товаров
    if (cart.cart) {
      cart.cart.forEach((item) => {
        // eslint-disable-next-line
        if (!item.quantity) item.quantity = 1;
      });
    }
    const prevCurrenciesKey = getCurrenciesCacheKey(state.cart);
    const nextCurrenciesKey = getCurrenciesCacheKey(cart);
    if (
      prevCurrenciesKey &&
      nextCurrenciesKey &&
      prevCurrenciesKey !== nextCurrenciesKey
    ) {
      invalidateCurrenciesCache(state, cart);
    }

    const prevTxKey = getPreviousTransactionCacheKey(state.cart);
    const nextTxKey = getPreviousTransactionCacheKey(cart);
    if (prevTxKey && nextTxKey && prevTxKey !== nextTxKey) {
      invalidatePreviousTransactionCache(state, cart);
    }

    state.cart = cart;
  },
  setInitialCart(state, cart) {
    // это чтобы не было конфликтов, если кто-то не передает кол-во товаров
    if (cart.cart) {
      cart.cart.forEach((item) => {
        // eslint-disable-next-line
        if (!item.quantity) item.quantity = 1;
      });
    }
    state.initialCart = cart;
  },
  setRedirectUrl(state, info) {
    state.redirectUrl = info;
  },
  setGlobalIframeRedirect(state, info) {
    state.enableGlobalIframeRedirect = info;
  },
  setMerchantIframeRedirect(state, info) {
    state.enableMerchantIframeRedirect = info;
  },
  clearCart(state) {
    state.cart = {};
  },
  setTxs(state, txs) {
    state.txs = txs;
  },
  setStores(state, stores) {
    state.stores = stores;
  },
  setExtensionHeight(state, height) {
    state.extensionHeight = height;
  },
  setUserSettings(state, settings) {
    // set merchant currency as the default currency in case no
    // setting is done
    if (!settings.isUserConfigured) {
      // check that the currency should be an enabled currency
      // state.currencies.forEach((currency) => {
      //   if (helper.getLowerCase(currency.id)
      //         === helper.getLowerCase(state.cart.currency)) {
      // eslint-disable-next-line no-param-reassign
      settings.displayCurrency = state.cart.currency;
      // }
      // });
    }
    state.settings = settings;
  },
  setCurrencies(state, currencies) {
    const nextSig = currenciesListSignature(currencies);
    const prevSig = currenciesListSignature(state.currencies);
    if (nextSig && nextSig === prevSig) {
      return;
    }
    state.currencies = currencies;
  },
  setCurrenciesCacheKey(state, key) {
    state.apiCache.currenciesKey = key;
  },
  setDisplayCurrency(state, currency) {
    state.displayCurrency = currency;
  },
  setMarketInfo(state, info) {
    state.marketInfo = info;
  },
  setExchanges(state, data) {
    const exchanges = [];
    let icon;
    data.forEach((exchange) => {
      // TODO надо что-то придумать с банками
      // if (exchange.isEnabled && exchange.nameStock !== 'silamoney') {
      try {
        // eslint-disable-next-line
        icon = require(`@/assets/img/wallets/${exchange.nameStock}.svg`);
      } catch {
        // eslint-disable-next-line
        icon = require("@/assets/img/wallets/bank.svg");
      }
      exchanges.push({
        name: exchange.logo,
        value: exchange.nameStock,
        // eslint-disable-next-line
        icon,
        connect: exchange.nameStock,
        currencies: exchange.currencies,
      });
      // }
    });
    state.allStocks = exchanges;
  },
  setPaymentOptions(state, data) {
    state.paymentOptions = data;
  },
  setIsLogoutCheckUp(state, data) {
    state.isLogin = data;
  },
  setStockExchanges(state, data) {
    state.stockExchanges = data;
  },
  setSelectedExchange(state, data) {
    state.selectedExchange = data;
  },
  setAccount(state, data) {
    state.bankAccount = data;
  },
  setTab(state, data) {
    state.tab = data;
  },
  continuedTransaction(state, data) {
    state.continuedTransaction = data;
  },
  setSocketResponse(state, data) {
    state.socketResponse = data;
  },
  setCryptoWalletStep(state, data) {
    state.cryptoWalletStep = data;
  },
  setIsInstructionsRepeated(state, data) {
    state.isInstructionsRepeated = data;
  },
  setIsLoginWithoutEmail(state, data) {
    state.isLoginWithoutEmail = data;
  },
  setIsIframeOpenEmitted(state, data) {
    state.isIframeOpenEmitted = data;
  },
  setIframeDismissConfirmVisible(state, visible) {
    state.iframeDismissConfirmVisible = !!visible;
  },
  setSessionNotifyStatus(state, data) {
    state.sessionNotifyStatus = data;
  },
  setHostedPageId(state, hostedPageId) {
    state.hostedPageId = hostedPageId;
  },
  setResultPageData(state, data) {
    state.resultPageData.title = data.title;
    state.resultPageData.icon = data.icon;
    state.resultPageData.description = data.description;
    state.resultPageData.paymentData = data?.paymentData || null;
    state.resultPageData.isFasterCoin = data?.isFasterCoin;
  },
  setFeedbackState(state, data) {
    state.showFeedback = data;
  },
  setRefrenceId(state, data) {
    state.refrenceId = data;
  },
  setEnrolledInRewards(state, data) {
    state.enrolledInRewards = data;
  },
  setRewardsOptInPending(state, data) {
    state.rewardsOptInPending = data === true;
  },
  setRewardModal(state, data) {
    state.showRewardModal = data;
  },
  setEstimatedRewards(state, data) {
    state.estimatedRewards = data;
  },
  setRewardsBalance(state, data) {
    state.rewardsBalance = data;
  },
  setFsStatus(state, data) {
    state.fsStatus = data;
  },
};
